import { render } from "./Payxpert.vue?vue&type=template&id=432bd567&scoped=true"
import script from "./Payxpert.vue?vue&type=script&lang=js"
export * from "./Payxpert.vue?vue&type=script&lang=js"

import "./Payxpert.vue?vue&type=style&index=0&id=432bd567&lang=css"
import "./Payxpert.vue?vue&type=style&index=1&id=432bd567&lang=scss&scoped=true"

import exportComponent from "/home/cellposition/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432bd567"]])

export default __exports__